import {RatingsError} from './RatingsError.js'

export class CancelTradeRatingsError extends RatingsError {}
